import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-graphic-header',
  templateUrl: './ticket-graphic-header.component.html',
  styleUrls: ['./ticket-graphic-header.component.scss'],
})
export class TicketGraphicHeaderComponent implements OnInit {

  @Input()
  padding: number = 40;

  constructor() { }

  getPadding(): string {
    return `0 ${this.padding}px`;
  }

  ngOnInit() {}

}
